import React, { useRef, useState, useEffect } from "react";

export default function HTMLtest(props) {
  const correctAnswers = [0, 0, 2, 0, 1, 1, 0, 0, 0, 1, 0, 2, 0, 2, 2, 1, 0, 1, 2, 0, 0, 0, 0, 2, 1];
  const que = {
    q1: {
      string: "1. What does HTML stand for?",
      options: ["Hyper Text Markup Language", "Home Tool Markup Language", "Hyperlinks and Text Markup Language", "Hyperlinking Text Marking Language"],
      ans: 0
    },
    q2: {
      string: "2. Who is the primary author of HTML?",
      options: ["Tim Berners-Lee", "Vint Cerf", "Robert Cailliau", "Larry Page"],
      ans: 0
    },
    q3: {
      string: "3. Which tag is used for creating a hyperlink?",
      options: ["<link>", "<href>", "<a>", "<hyperlink>"],
      ans: 2
    },
    q4: {
      string: "4. Which HTML element is used to define the largest heading?",
      options: ["<h1>", "<heading>", "<h6>", "<head>"], ans: 0
    },
    q5: {
      string: "5. Which tag is used to create a numbered list?",
      options: ["<ul>", "<ol>", "<li>", "<list>"],
      ans: 1
    },
    q6: {
      string: "6. Which element is used to create a form in HTML?",
      options: ["<input>", "<form>", "<field>", "<fieldset>"],
      ans: 1
    },
    q7: {
      string: "7. How do you create a text input field in a form?",
      options: ["<input type='text'>", "<textfield>", "<input type='textfield'>", "<input type='textfield'>"],
      ans: 0
    },
    q8: {
      string: "8. Which attribute specifies where to send the form data?",
      options: ["action", "method", "enctype", "target"],
      ans: 0
    },
    q9: {
      string: "9. How do you create a radio button in HTML?",
      options: ["<input type='radio'>", "<input type='button'>", "<radio>", "<button>"],
      ans: 0
    },
    q10: {
      string: "10. Which attribute is used to define the name of a form control?",
      options: ["id", "name", "value", "type"],
      ans: 1
    },
    q11: {
      string: "11. Which tag is used to embed an image in an HTML page?",
      options: ["<img>", "<image>", "<pic>", "<src>"],
      ans: 0
    },
    q12: {
      string: "12. What is the correct HTML element for playing video files?",
      options: ["<movie>", "<media>", "<video>", "<film>"], ans: 2
    },
    q13: {
      string: "13. How can you make a numbered list?",
      options: ["<ol>", "<ul>", "<dl>", "<list>"],
      ans: 0
    },
    q14: {
      string: "14. Which HTML attribute specifies an alternate text for an image, if the image cannot be displayed?",
      options: ["title", "src", "alt", "longdesc"],
      ans: 2
    },
    q15: {
      string: "15. How do you embed an audio file in HTML?",
      options: ["<mp3>", "<sound>", "<audio>", "<voice>"],
      ans: 2
    },
    q16: {
      string: "16. Which tag is used to define a table in HTML?",
      options: ["<tbl>", "<table>", "<td>", "<tab>"],
      ans: 1
    },
    q17: {
      string: "17. What does the <th> tag define in an HTML table?",
      options: ["Table header", "Table row", "Table data", "Table footer"],
      ans: 0
    },
    q18: {
      string: "18. Which HTML element is used to define the footer for a document or section?",
      options: ["<bottom>", "<footer>", "<section>", "<foot>"],
      ans: 1
    },
    q19: {
      string: "19. What is the correct HTML element for the largest heading?",
      options: ["<head>", "<h6>", "<h1>", "<heading>"],
      ans: 2
    },
    q20: {
      string: "20. Which element is used to create a dropdown list?",
      options: ["<select>", "<option>", "<list>", "<dropdown>"],
      ans: 0
    },
    q21: {
      string: "21. How do you specify a comment in HTML?",
      options: ["<!-- Comment -->", "// Comment", "/* Comment */", "** Comment **"],
      ans: 0
    },
    q22: {
      string: "22. What is the purpose of the <meta> tag in HTML?",
      options: ["To provide metadata about the HTML document", "To link to external files", "To create a line break", "To define a table"],
      ans: 0
    },
    q23: {
      string: "23. Which tag is used to define a client-side image map?",
      options: ["<map>", "<area>", "<img>", "<usemap>"],
      ans: 0
    },
    q24: {
      string: "24. How do you specify a background color in HTML?",
      options: ["<body bg='color'>", "<body color='color'>", "<body bgcolor='color'>", "<background color='color'>"],
      ans: 2
    },
    q25: {
      string: "25. Which HTML element is used to specify a section of a document?",
      options: ["<div>", "<section>", "<article>", "<header>"],
      ans: 1
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>HTML <span>Skill</span> Test</h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1>
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
            <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
